/* assets/ai-art-engine.js */

const WORKER_API_URL =
"https://proud-base-7866.mmmonroejudson.workers.dev";

const CLOUDINARY_URL =
"https://api.cloudinary.com/v1_1/dbbcn7aot/image/upload";

const CLOUDINARY_PRESET =
"zalanda_swap";



async function zalandaCompressor(
file,
{
maxWidth=1024,
quality=0.75
}={}
){

return new Promise((resolve)=>{

const reader=new FileReader();

reader.readAsDataURL(file);


reader.onload=(e)=>{

const img=new Image();

img.src=e.target.result;


img.onload=()=>{


const canvas=document.createElement("canvas");

let width=img.width;
let height=img.height;


if(width>maxWidth){

height=Math.round(
height*maxWidth/width
);

width=maxWidth;

}


canvas.width=width;
canvas.height=height;


canvas
.getContext("2d")
.drawImage(
img,
0,
0,
width,
height
);



canvas.toBlob(

(blob)=>{

resolve(

new File(

[blob],

file.name.replace(
/\.[^/.]+$/,
""
)+".jpg",

{
type:"image/jpeg"
}

)

);

},

"image/jpeg",

quality

);


};


};


});


}



async function uploadToCloudinary(file){

const fd=new FormData();

fd.append(
"file",
file
);

fd.append(
"upload_preset",
CLOUDINARY_PRESET
);



const response=await fetch(

CLOUDINARY_URL,

{

method:"POST",

body:fd

}

);



if(!response.ok){

throw new Error(
`Cloudinary Upload Failed: ${await response.text()}`
);

}



const data=
await response.json();


return data.secure_url;

}




function getNextTemplateUrl(styleKey){


const config=
window.ART_CONFIG.get(styleKey);



const templates=
config.assets.templates;



let lastIndex=
Number(
AI_STORAGE.get(
"last_index",
0
)
);



if(isNaN(lastIndex)){

lastIndex=0;

}



const currentTemplate=
templates[
lastIndex % templates.length
];



AI_STORAGE.set(

"last_index",

(
lastIndex+1
)
%
templates.length

);



console.log(

`[Engine] Product: ${window.CURRENT_SKU} | Template: ${currentTemplate}`

);



return currentTemplate;


}






async function processArtGeneration(
rawFile,
styleKey
){


const config=
window.ART_CONFIG.get(
styleKey
);



if(!config){

throw new Error(
`Engine Error: Configuration for "${styleKey}" is missing.`
);

}



console.log(
`---------- [Engine Start: ${config.product.name}] ----------`
);



try{


const compressedFile=
await zalandaCompressor(
rawFile
);



const templateUrl=
getNextTemplateUrl(
styleKey
);



const userPhotoUrl=
await uploadToCloudinary(
compressedFile
);




// ===============================
// AI Gift / Custom Text Payload
// ===============================

const giftData =

window.AI_GIFT_MESSAGE &&

window.AI_GIFT_MESSAGE.enabled

?

JSON.stringify(
window.AI_GIFT_MESSAGE
)

:

"";




// ===============================
// Worker Request
// ===============================

const payload={


base_image:
templateUrl,


swap_image:
userPhotoUrl,


style:
config.ai.style,


sku1:

config.ai.sku1

||

config.product.sku,



sku2:

giftData

||

window.CURRENT_AI_TEXT

||

config.ai.sku2

||

"",



...config.ai.options


};



console.log(
"[AI Generation Payload]",
payload
);





const generateResponse=

await fetch(

WORKER_API_URL,

{

method:"POST",

headers:{

"Content-Type":
"application/json"

},


body:

JSON.stringify(
payload
)


}

);





if(!generateResponse.ok){

throw new Error(
`Worker Error: ${generateResponse.statusText}`
);

}





const {

image_urls

}

=

await generateResponse.json();






const finalHdUrls=

await Promise.all(

image_urls.map(

url=>

uploadToCloudinary(url)

)

);






console.log(

`---------- [Engine Complete: ${config.product.name}] ----------`

);



return finalHdUrls;



}

catch(error){


console.error(

"Engine Runtime Error:",

error

);


throw error;


}


}





window.processArtGeneration=
processArtGeneration;